module.exports = __webpack_public_path__ + "img/glow-yellow-small.d5956c31.png";